import React from 'react'
import {
  Modal,
} from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import  PreviewFile from '../PreviewFile';

export default NiceModal.create(({ fileId }) => {
  const modal = useModal()
  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      dialogPanelClasses="max-w-screen-2xl h-screen overflow-x-scroll"
    >
        <PreviewFile fileId={fileId} />
    </Modal>
  )
})
